
const OrderSetHeader = ({ headerText, className = "" }: { headerText: string, className?: string }) => {
    return (
        <div className={`d-flex align-items-center ${className}`}>
            <div className="fs-5 fw-semibold">{headerText}</div>
        </div>
    );
};

export default OrderSetHeader;
